define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/xml",
	"./NewColorwayFromColor",
	"./Theme/ThemeColorwayToColorwayMappingMixin"
], function(declare,lang,_,xml,NewColorwayFromColor,ThemeColorwayToColorwayMappingMixin) {

	return declare([NewColorwayFromColor, ThemeColorwayToColorwayMappingMixin], {
		getFormData: function() {
			// summary: add hook into form data to determine if node is already selected
			var	fd = this.inherited(arguments);
			fd.m_fAggregateSelected = lang.hitch(this, this._isPreSelected);
			return fd;
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default values for form - this function is also called for the popup table in which case we don't have to do anything
			this.inherited(arguments);

			const ccc = view.defView.m_formData.getSelectedNode();
			if (ccc) {
				this.urlColor = ccc.$URL;
				view.addDefaultValue(xml.ATTR_NAME, ccc.$Name);
				view.addDefaultValue("CarryOver", ccc.CarryOver);
				view.addFixedValue("ColorwayThemeColor", this.urlColor);
				view.addFixedValue("ColorSpecification", ccc.Actual);

				// make sure new ColorSpecification will be in cache for form
				view.cacheView.getNode(ccc.Actual, true);
			}
		},

		_isPreSelected: function(/*csi.def.Context*/ctx, /*csi.action.FormData*/fd) {
			// summary: determine if ColorColorwayContext.Actual is in aggregation list
			let	node = ctx.getNode();
			let amap = fd._mapAggregated;

			// Check if ColorSpecification ref for ColorColorwayContext
			// is same for one of the Colorway nodes in the aggregation list
			for (const colorwayUrl in amap) {
				if (amap[colorwayUrl].ColorSpecification === node.Actual) {
					return true;
				}
			}

			return false;
		},

		_processFormData: function(/*FormData*/fd) {
			// summary: S12391 call method to update mapped attributes from Theme Colorway
			// if a mapping exists
			var	ret = this.inherited(arguments);

			if (this.urlColor && this._isColorwayAttributeMappingExists(this.getCache().getNode(this.urlColor))) {
				_.each(this.urlsAppended, function(url) {
					this._updateMappedAttributes(url);
				}, this);
			}

			return ret;
		},

		_updateMappedAttributes: function (/*String*/urlColorway) {
			// summary: S12391 call method to update mapped attributes from Theme Colorway
			this.m_writer.callMethod("Apparel", "ColorwayUpdateMappedAttributes")
				.addParameter("ColorColorwayContext", xml.ATTR_REF, this.urlColor)
				.addParameter(xml.PROP_URL, xml.ATTR_REF, urlColorway);
		}

	});
});